export default {
    action: 'Add to work space or pin to macro-trend',
    title: 'Micro-trend',
    subtitle: 'Add to a work space',
    submit: 'Done',
    success: 'The micro-trend <strong>"{title}"</strong> was successfully added to a work space.',
    error: 'An error occured: <strong>"{title}"</strong>.'
}
